import emailValidator from 'email-validator';

export const validateEmail = emailValidator.validate;
